module.exports = __webpack_public_path__ + "static/media/Rob Brantley.71c7020f.png";